import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ProductListComponent } from './pages/product-list/product-list.component';
import { ProductFormComponent } from './pages/product-form/product-form.component';
import { CategoryListComponent } from './pages/category-list/category-list.component';
import { BannerListComponent } from './pages/banner-list/banner-list.component';
import { BannerFormComponent } from './pages/banner-form/banner-form.component';
import { OptionsListComponent } from './pages/options-list/options-list.component';
import { EnquiryListComponent } from './pages/enquiry-list/enquiry-list.component';
import { OrderListComponent } from './pages/order-list/order-list.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { BrandGroupsComponent } from './pages/brand-groups/brand-groups.component';
import { BulkUploadComponent } from './pages/bulk-upload/bulk-upload.component';
import { ReviewListComponent } from './pages/review-list/review-list.component';
import { CouponsComponent } from './pages/coupons/coupons.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'enquiries', component: EnquiryListComponent, canActivate: [authGuard] },
  { path: 'orders', component: OrderListComponent, canActivate: [authGuard] },
  { path: 'orders/:id', component: OrderDetailComponent, canActivate: [authGuard] },
  { path: 'reviews', component: ReviewListComponent, canActivate: [authGuard] },
  { path: 'coupons', component: CouponsComponent, canActivate: [authGuard] },
  { path: 'products', component: ProductListComponent, canActivate: [authGuard] },
  { path: 'products/new', component: ProductFormComponent, canActivate: [authGuard] },
  { path: 'products/edit/:id', component: ProductFormComponent, canActivate: [authGuard] },
  { path: 'categories', component: CategoryListComponent, canActivate: [authGuard] },
  { path: 'collections', component: CategoryListComponent, canActivate: [authGuard] },
  { path: 'subcategories', component: CategoryListComponent, canActivate: [authGuard] },
  { path: 'banners', component: BannerListComponent, canActivate: [authGuard] },
  { path: 'banners/new', component: BannerFormComponent, canActivate: [authGuard] },
  { path: 'banners/edit/:id', component: BannerFormComponent, canActivate: [authGuard] },
  { path: 'options', component: OptionsListComponent, canActivate: [authGuard] },
  { path: 'brand-groups', component: BrandGroupsComponent, canActivate: [authGuard] },
  { path: 'bulk-upload', component: BulkUploadComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: 'dashboard' }
];
